const routes = [
    {
        path: "/student/documents/create",
        component: () => import("../pages/Create"),
        meta: {
            isAuthenticated: true,
            permission: "studentdocument_create"
        },
        component_full_path: 'studentDocument/pages/Create'
    },
];

export default routes;
